<div class="row empty-state" *ngIf="deploys?.length === 0 && emptyProject">
  <div class="col-md-12">
    <h1>We haven't received any deployments from this project yet</h1>
  </div>
  <div class="col-md-6">
    <h2 class="mt-4">Why track deploys?</h2>
    <div class="row mb-3 pt-3">
      <div class="col-md-6">
        <h4>See who deployed exactly what changes, and when</h4>
      </div>
      <div class="col-md-6">
        <img
          class="feature-thumb"
          src="{{ appEnv.cdnUrl }}/{{
            appEnv.assetsPath
          }}/images/feature-deploys-01.png"
          srcset="
            {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/feature-deploys-01.png    1x,
            {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/feature-deploys-01@2x.png 2x
          "
        />
      </div>
    </div>
    <div class="row mb-3 pt-3">
      <div class="col-md-6">
        <h4>See which deploys fixed which errors</h4>
      </div>
      <div class="col-md-6">
        <img
          class="feature-thumb"
          src="{{ appEnv.cdnUrl }}/{{
            appEnv.assetsPath
          }}/images/feature-deploys-02.png"
          srcset="
            {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/feature-deploys-02.png    1x,
            {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/feature-deploys-02@2x.png 2x
          "
        />
      </div>
    </div>
    <div class="row mb-3 pt-3">
      <div class="col-md-6">
        <h4>See which deploys introduced new errors</h4>
      </div>
      <div class="col-md-6">
        <img
          class="feature-thumb"
          src="{{ appEnv.cdnUrl }}/{{
            appEnv.assetsPath
          }}/images/feature-deploys-03.png"
          srcset="
            {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/feature-deploys-03.png    1x,
            {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/feature-deploys-03@2x.png 2x
          "
        />
      </div>
    </div>
    <div class="row mb-3 pt-3">
      <div class="col-md-6">
        <h4>
          See trends in how your deploys are affecting errors on your project
        </h4>
      </div>
      <div class="col-md-6">
        <img
          class="feature-thumb"
          src="{{ appEnv.cdnUrl }}/{{
            appEnv.assetsPath
          }}/images/feature-deploys-04.png"
          srcset="
            {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/feature-deploys-04.png    1x,
            {{appEnv.cdnUrl}}/{{appEnv.assetsPath}}/images/feature-deploys-04@2x.png 2x
          "
        />
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <h2 class="mt-4">How do I track deploys?</h2>
    <h3 class="mt-4">Using the Airbrake CLI </h3>
    <p>
      You can track deploys with the Airbrake CLI. First
      <ab-external-link
        href="https://github.com/airbrake/airbrake-cli#installation">
        install
      </ab-external-link>
      the CLI then authenticate via
      <ab-external-link
        href="https://github.com/airbrake/airbrake-cli#login-command">
        the login command
      </ab-external-link>
      or add your user key via
      <ab-external-link
        href="https://github.com/airbrake/airbrake-cli#config-command">
        the config command
      </ab-external-link>
      then invoke the deploy command like the following example:
    </p>

    <pre class="pre-break">
airbrake deploys create \
  --project-id {{ project.id }} \
  --user john \
  --env production \
  --repository https://github.com/USERNAME/REPO \
  --revision 38748467ea579e7ae64f7815452307c9d05e05c5</pre>

    <h3 class="mt-4">Using cURL</h3>
    <p>
      You can track a deploy with a <code>POST</code> to the
      <code>/v4/deploys</code>&nbsp;<ab-external-link
        href="https://airbrake.io/docs/api/#create-deploy-v4"
        >API endpoint</ab-external-link
      >.
    </p>
    <p>
      You want to trigger a <code>POST</code> each time you deploy, specifying
      at least your <code>PROJECT_ID</code>, <code>PROJECT_KEY</code> and
      <code>environment</code> in the JSON data. If you also provide a
      <code>repository</code> and <code>revision</code>, this will enable us to
      build links in backtraces that link to your repository.
    </p>
    <p>
      You can find your <code>PROJECT_KEY</code> in the
      <a href="/projects/{{ project.id }}/edit" target="_self"
        >project settings</a
      >.
    </p>
    <h3 class="mt-4">Example cURL command</h3>
    <pre class="pre-break">
curl -X POST -H "Content-Type: application/json" \
-d '{{
        "{"
      }}"environment":"production","username":"john","repository":"https://github.com/USERNAME/REPO","revision":"38748467ea579e7ae64f7815452307c9d05e05c5"{{
        "}"
      }}' \
"https://api.airbrake.io/api/v4/projects/{{
        project.id
      }}/deploys?key=PROJECT_KEY"</pre
    >
    <p>
      Read more
      <ab-external-link
        href="https://docs.airbrake.io/docs/features/deploy-tracking/"
      >
        in our docs </ab-external-link
      >.
    </p>
  </div>
</div>

<div *ngIf="!emptyProject">
  <h4>
    <div class="btn-group btn-group-sm">
      <button
        class="btn"
        type="button"
        (click)="updateChart({ chartType: 'group' })"
        [ngClass]="{ active: chartType === 'group' }"
        [disabled]="chartType === 'group'"
      >
        Error statistics
      </button>
      <button
        class="btn"
        type="button"
        (click)="updateChart({ chartType: 'deploy' })"
        [ngClass]="{ active: chartType === 'deploy' }"
        [disabled]="chartType === 'deploy'"
      >
        Occurrence rate
      </button>
    </div>
    per deploy to:
    <ng-select
      #ngSelect
      class="deploys-env-selector"
      [(ngModel)]="environment"
      (close)="ngSelect.blur()"
      (change)="updateChart({ environment: environment, page: 1 })"
      [disabled]="loading"
      [clearable]="false"
      placeholder="all"
    >
      <ng-option
        class="text-truncate"
        *ngFor="let env of environments; trackBy: trackByIndex"
        [value]="env"
        [disabled]="isDisabled(env)"
        >{{ env }}</ng-option
      >
    </ng-select>

    <div class="paginate float-md-right">
      <div class="deploy-counter" *ngIf="deploys?.length > 0">
        {{ totalDeploys }} Deploys, Page {{ currentPage }} of {{ totalPages }}
      </div>
      <div class="btn-group">
        <button
          class="btn"
          (click)="updateChart({ page: currentPage - 1 })"
          [disabled]="!hasPreviousPage() || loading"
          type="button"
        >
          <i class="glyphicon glyphicon-angle-left"></i>
        </button>
        <button
          class="btn"
          (click)="updateChart({ page: currentPage + 1 })"
          [disabled]="!hasNextPage() || loading"
          type="button"
        >
          <i class="glyphicon glyphicon-angle-right"></i>
        </button>
      </div>
    </div>
  </h4>
  <ab-deploy-barchart
    [data]="chartData"
    [environment]="environment"
    [mode]="chartType"
    [loading]="loading"
  ></ab-deploy-barchart>
</div>
<div
  class="blankslate"
  *ngIf="!loading && !emptyProject && deploys?.length === 0"
>
  <p class="blankslate__text">No data for the chosen time period</p>
  <img
    class="blankslate__image"
    src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/blankslate.svg"
  />
</div>
<div class="ab-table-wrap" *ngIf="deploys?.length > 0 && !loading">
  <div class="ab-table">
    <div class="ab-table__row-grid ab-table__row-grid--9-columns">
      <div class="ab-table__header"></div>
      <div class="ab-table__header"></div>
      <div class="ab-table__header"></div>
      <div class="ab-table__header"></div>
      <div class="ab-table__header"></div>
      <div class="ab-table__header ab-table__header--left-border">Errors</div>
      <div class="ab-table__header"></div>
      <div class="ab-table__header ab-table__header--left-border">
        Occurrences
      </div>
      <div class="ab-table__header"></div>
    </div>
  </div>
  <div class="ab-table">
    <div class="ab-table__row-grid ab-table__row-grid--9-columns">
      <div class="ab-table__header">
        <a class="th-link" (click)="sortBy('username')"
          >Name<i
            class="glyphicon th-link__icon"
            *ngIf="column === 'username'"
            [ngClass]="{
              'glyphicon-caret-up': !sortDesc,
              'glyphicon-caret-down': sortDesc
            }"
          ></i
        ></a>
      </div>
      <div class="ab-table__header">
        <a class="th-link" (click)="sortBy('revision')"
          >Revision<i
            class="glyphicon th-link__icon"
            *ngIf="column === 'revision'"
            [ngClass]="{
              'glyphicon-caret-up': !sortDesc,
              'glyphicon-caret-down': sortDesc
            }"
          ></i
        ></a>
      </div>
      <div class="ab-table__header">
        <a class="th-link" (click)="sortBy('totalChanges')"
          >Changes<i
            class="glyphicon th-link__icon"
            *ngIf="column === 'totalChanges'"
            [ngClass]="{
              'glyphicon-caret-up': !sortDesc,
              'glyphicon-caret-down': sortDesc
            }"
          ></i
        ></a>
      </div>
      <div class="ab-table__header">
        <a class="th-link" (click)="sortBy('environment')"
          >Environment<i
            class="glyphicon th-link__icon"
            *ngIf="column === 'environment'"
            [ngClass]="{
              'glyphicon-caret-up': !sortDesc,
              'glyphicon-caret-down': sortDesc
            }"
          ></i
        ></a>
      </div>
      <div class="ab-table__header">
        <a class="th-link" (click)="sortBy('createdAt')"
          >Time<i
            class="glyphicon th-link__icon"
            *ngIf="column === 'createdAt'"
            [ngClass]="{
              'glyphicon-caret-up': !sortDesc,
              'glyphicon-caret-down': sortDesc
            }"
          ></i
        ></a>
      </div>
      <div class="ab-table__header ab-table__header--left-border">
        <a
          class="th-link"
          (click)="sortBy('groupResolvedCount')"
          ngbTooltip="Errors that have not reoccurred since the deploy marked them as resolved."
          >Fixed<i
            class="glyphicon th-link__icon"
            *ngIf="column === 'groupResolvedCount'"
            [ngClass]="{
              'glyphicon-caret-up': !sortDesc,
              'glyphicon-caret-down': sortDesc
            }"
          ></i
        ></a>
      </div>
      <div class="ab-table__header">
        <a
          class="th-link"
          (click)="sortBy('groupCreatedCount')"
          ngbTooltip="Errors that were first seen while the deploy was active."
          >Introduced<i
            class="glyphicon th-link__icon"
            *ngIf="column === 'groupCreatedCount'"
            [ngClass]="{
              'glyphicon-caret-up': !sortDesc,
              'glyphicon-caret-down': sortDesc
            }"
          ></i
        ></a>
      </div>
      <div class="ab-table__header ab-table__header--left-border">
        <a
          class="th-link"
          (click)="sortBy('noticeTotalCount')"
          ngbTooltip="Total error occurrences while the deploy was active."
          >Count<i
            class="glyphicon th-link__icon"
            *ngIf="column === 'noticeTotalCount'"
            [ngClass]="{
              'glyphicon-caret-up': !sortDesc,
              'glyphicon-caret-down': sortDesc
            }"
          ></i
        ></a>
      </div>
      <div class="ab-table__header">
        <a
          class="th-link"
          (click)="sortBy('occurrenceRate')"
          ngbTooltip="Frequency of error occurences while the deploy was active."
          >Rate<i
            class="glyphicon th-link__icon"
            *ngIf="column === 'occurrenceRate'"
            [ngClass]="{
              'glyphicon-caret-up': !sortDesc,
              'glyphicon-caret-down': sortDesc
            }"
          ></i
        ></a>
      </div>
    </div>
  </div>
  <div class="ab-table">
    <div
      class="ab-table__row-grid ab-table__row-grid--9-columns ab-table__row-hoverable"
      *ngFor="let deploy of deploys; trackBy: trackById"
    >
      <a
        class="ab-table__cell"
        uiSref="deploys-show"
        [uiParams]="{ projectId: project.id, deployId: deploy.id }"
        >{{ deploy.username }}</a
      >
      <a
        class="ab-table__cell"
        uiSref="deploys-show"
        [uiParams]="{ projectId: project.id, deployId: deploy.id }"
      >
        <span *ngIf="!deploy.revision"><em>unknown</em></span>
        <span *ngIf="deploy.revision"
          >{{ deploy.revision | truncate: 7 }}
          <i
            *ngIf="deploy.redeploy"
            class="glyphicon glyphicon-ab-layers"
            ngbTooltip="Redeploy"
          ></i>
        </span>
      </a>
      <a
        class="ab-table__cell"
        uiSref="deploys-show"
        [uiParams]="{ projectId: project.id, deployId: deploy.id }"
      >
        <ab-diff-stat-blocks
          [deploy]="deploy"
          [displayEmptyState]="true"
        ></ab-diff-stat-blocks>
      </a>
      <a
        class="ab-table__cell"
        uiSref="deploys-show"
        [uiParams]="{ projectId: project.id, deployId: deploy.id }"
      >
        <ab-env-label [env]="deploy.environment"></ab-env-label>
      </a>
      <a
        class="ab-table__cell"
        title="{{ deploy.createdAt | date: 'MMM dd, y HH:mm:ss Z' }}"
        uiSref="deploys-show"
        [uiParams]="{ projectId: project.id, deployId: deploy.id }"
      >
        <ab-time-ago [time]="deploy.createdAt"></ab-time-ago>
      </a>
      <a
        class="ab-table__cell color--success"
        *ngIf="deploy.groupResolvedCount > 0"
        uiSref="project-errors"
        [uiParams]="{
          projectId: project.id,
          filters: { resolved_by_deploy_id: deploy.id, resolved: 'any' }
        }"
        (click)="$event.stopPropagation()"
        >{{ deploy.groupResolvedCount | numberToHuman }}</a
      >
      <a
        class="ab-table__cell"
        *ngIf="deploy.groupResolvedCount === 0"
        uiSref="deploys-show"
        [uiParams]="{ projectId: project.id, deployId: deploy.id }"
        >-</a
      >
      <a
        class="ab-table__cell color--danger"
        *ngIf="deploy.groupCreatedCount > 0"
        uiSref="project-errors"
        [uiParams]="{
          projectId: project.id,
          filters: { deploy_id: deploy.id, resolved: 'any' }
        }"
        (click)="$event.stopPropagation()"
        >{{ deploy.groupCreatedCount | numberToHuman }}</a
      >
      <a
        class="ab-table__cell"
        *ngIf="deploy.groupCreatedCount === 0"
        uiSref="deploys-show"
        [uiParams]="{ projectId: project.id, deployId: deploy.id }"
        >-</a
      >
      <a
        class="ab-table__cell"
        *ngIf="deploy.noticeTotalCount > 0"
        uiSref="deploys-show"
        [uiParams]="{ projectId: project.id, deployId: deploy.id }"
        >{{ deploy.noticeTotalCount | numberToHuman }}</a
      >
      <a
        class="ab-table__cell"
        *ngIf="deploy.noticeTotalCount === 0"
        uiSref="deploys-show"
        [uiParams]="{ projectId: project.id, deployId: deploy.id }"
        >-</a
      >
      <a
        class="ab-table__cell"
        *ngIf="deploy.occurrenceRate >= 0.1"
        uiSref="deploys-show"
        [uiParams]="{ projectId: project.id, deployId: deploy.id }"
        >{{ deploy.occurrenceRate.toFixed(1) | numberToHuman }} / min</a
      >
      <a
        class="ab-table__cell"
        *ngIf="deploy.occurrenceRate < 0.1 && deploy.occurrenceRate > 0"
        uiSref="deploys-show"
        [uiParams]="{ projectId: project.id, deployId: deploy.id }"
        >~0 / min</a
      >
      <a
        class="ab-table__cell"
        *ngIf="deploy.occurrenceRate === 0"
        uiSref="deploys-show"
        [uiParams]="{ projectId: project.id, deployId: deploy.id }"
        >-</a
      >
    </div>
  </div>
</div>
<div class="deploy-footer" *ngIf="totalDeploys > 0">
  <div class="paginate float-md-right">
    <div class="deploy-counter">
      {{ totalDeploys }} Deploys, Page {{ currentPage }} of {{ totalPages }}
    </div>
    <div class="btn-group">
      <button
        class="btn"
        (click)="updateChart({ page: currentPage - 1 })"
        [disabled]="!hasPreviousPage() || loading"
        type="button"
      >
        <i class="glyphicon glyphicon-angle-left"></i>
      </button>
      <button
        class="btn"
        (click)="updateChart({ page: currentPage + 1 })"
        [disabled]="!hasNextPage() || loading"
        type="button"
      >
        <i class="glyphicon glyphicon-angle-right"></i>
      </button>
    </div>
  </div>
</div>
